import { Fragment } from 'react';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { TextKey, RouteName } from '@mews-commander/enums';
import { Container, IconName } from '@optimus-web/core';
import {
    canCurrentProfileViewSensitiveReports,
    canCurrentProfileViewCustomerData,
} from '@mews-commander/legacy-entities/src/selectors/session/scope';
import { EnterpriseLink } from '@mews-commander/ui';
import DashboardTitle from '../DashboardTitle';
import DashboardTextLink from '../DashboardTextLink';
import { useGetAccountingConfigurationReceivableTrackingEnabled } from '../../../payment/queries';
import { DashboardFontIcon, DashboardTextElement } from '../../style';

const FinanceLinksSection = ({ canViewSensitiveReports, canViewCustomerData }: $TSFixMe) => {
    const { data: receivableTrackingEnabled = false } = useGetAccountingConfigurationReceivableTrackingEnabled();

    return (
        <Fragment>
            <DashboardTitle textKey={TextKey.Finance} />
            <DashboardTextLink
                textKey={TextKey.AccountingLedgerReport}
                iconName={IconName.AccountingLedger}
                route={RouteName.AccountingLedgerReportIndex}
            />
            {canViewSensitiveReports && receivableTrackingEnabled && (
                <EnterpriseLink to="Finance/Ledgers/City" variant="basic">
                    <Container padding={['0', '0', '50', '0']}>
                        <DashboardFontIcon value={IconName.ManagerReport} />
                        <DashboardTextElement textKey={TextKey.CityLedger} />
                    </Container>
                </EnterpriseLink>
            )}
            <DashboardTextLink
                textKey={TextKey.PaymentReport}
                iconName={IconName.PaymentReport}
                route={RouteName.PaymentReportIndex}
            />
            {canViewSensitiveReports && (
                <DashboardTextLink
                    textKey={TextKey.AccountingReport}
                    iconName={IconName.Summary}
                    route={RouteName.AccountingReportIndex}
                />
            )}
            {canViewCustomerData && (
                <DashboardTextLink
                    textKey={TextKey.BillReport}
                    iconName={IconName.ProductReport}
                    route={RouteName.BillReportIndex}
                />
            )}
            <DashboardTextLink textKey={TextKey.Cashier} iconName={IconName.Cashier} route={RouteName.CashierDefault} />
        </Fragment>
    );
};

export default connect(
    createStructuredSelector({
        canViewSensitiveReports: canCurrentProfileViewSensitiveReports,
        canViewCustomerData: canCurrentProfileViewCustomerData,
    })
)(FinanceLinksSection);
